import { IDashboardContext } from "../../../contexts/dashboard-context";
import { isPhotoEditingPanelSupported } from "../photo-editing-panel/menu-info";
import { isPhotoFiltersPanelSupported } from "../photo-filters-panel/menu-info";

export function isPhotoEditingMenuSupported(
	zone: eXpress.core.IZone | null | undefined,
	dashboard: IDashboardContext,
) {
	// Enable when one of the childs is enabled
	return isPhotoEditingPanelSupported(zone) || isPhotoFiltersPanelSupported(zone, dashboard);
}
